import {
    ChevronLeft,
    ChevronRight,
    Copy,
    CreditCard,
    MoreVertical,
    Truck,
} from "lucide-react";

import { Button } from "../../comps/ui/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../../comps/ui/cards";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../comps/ui/dropdown-menu";
import {
    Pagination,
    PaginationContent,
    PaginationItem,
} from "../../comps/ui/pagination";
import { Separator } from "../../comps/ui/separator";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export const OrderDetails = () => {
    const data  = useLocation().state;
    const orderInfo = data[0][data[1]];
    const [total,setTotal] = useState(0);
    const [tax, setTax] = useState(0);

    useEffect(() => {
        let new_total = 0;
        orderInfo.products.map((item) => {
            new_total = new_total + item.quantity*item.actual_price;
        })
        setTotal(new_total);
    },[]);
   

    return(
        <main className="flex-1 items-start p-4 sm:px-6 sm:py-0 md:gap-8 lg:grid-cols-3 xl:grid-cols-3">
            <Card className="overflow-hidden">
                <CardHeader className="flex flex-row items-start bg-muted/50">
                    <div className="grid gap-0.5">
                        <CardTitle className="group flex items-center gap-2 text-lg">
                            Order Id: {orderInfo.OrderID}
                            <Button
                                size="icon"
                                variant="outline"
                                className="h-6 w-6 opacity-1 transition-opacity group-hover:opacity-100"
                            >
                                <Copy className="h-3 w-3" />
                                <span className="sr-only">Copy Order ID</span>
                            </Button>
                        </CardTitle>
                        <CardDescription>
                            Date: {orderInfo.date}
                        </CardDescription>
                    </div>
                    <div className="ml-auto flex items-center gap-1">
                        <Button size="sm" variant="outline" className="h-8 gap-1">
                            <Truck className="h-3.5 w-3.5" />
                            <span className="lg:sr-only xl:not-sr-only xl:whitespace-nowrap">
                                Track Order
                            </span>
                        </Button>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button
                                    size="icon"
                                    variant="outline"
                                    className="h-8 w-8"
                                >
                                    <MoreVertical className="h-3.5 w-3.5" />
                                    <span className="sr-only">More</span>
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                                <DropdownMenuItem>
                                    <button>
                                        <Link 
                                            to="/user/dashboard/orders/invoice"
                                            state={[orderInfo, tax, total]}>Export</Link>
                                    </button>
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                </CardHeader>
                <CardContent className="p-6 text-sm">
                    <div className="grid gap-3">
                        <div className="font-semibold">Order Details</div>
                        <ul className="grid gap-3 text-base">
                            {orderInfo.products.map((item) => ( 
                                <li className="flex items-center justify-between">
                                    <span className="flex flex-col w-full">
                                        {item.title}
                                        <span className="text-muted-foreground text-sm">
                                            {item.manufacturer}
                                        </span>
                                    </span>
                                    <span className="w-full">{item.quantity} x ₹ {item.actual_price}</span>
                                    <span className="w-full text-right">₹ {item.quantity*item.actual_price}</span>
                                </li>
                            ))}
                        </ul>
                        <Separator className="my-2" />
                        <ul className="grid gap-3">
                            <li className="flex items-center justify-between">
                                <span className="text-muted-foreground">
                                    Subtotal
                                </span>
                                <span>₹ {total}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <span className="text-muted-foreground">
                                    Shipping
                                </span>
                                <span>₹ 250.0</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <span className="text-muted-foreground">Tax</span>
                                <span>₹ {tax}</span>
                            </li>
                            <li className="flex items-center justify-between font-semibold text-base">
                                <span className="text-muted-foreground">Total</span>
                                <span>₹ {total + tax}</span>
                            </li>
                        </ul>
                    </div>
                    <Separator className="my-4" />
                    <div className="grid grid-cols-2 gap-4">
                        <div className="grid gap-3">
                            <div className="font-semibold">
                                Shipping Information
                            </div>
                            <address className="grid gap-0.5 not-italic text-muted-foreground">
                                <span>{orderInfo.Location}</span>
                            </address>
                        </div>
                        <div className="grid auto-rows-max gap-3">
                            <div className="font-semibold">Billing Information</div>
                            <div className="text-muted-foreground">
                                Same as shipping address
                            </div>
                        </div>
                    </div>
                    <Separator className="my-4" />
                    <div className="grid gap-3">
                        <div className="font-semibold">Customer Information</div>
                        <dl className="grid gap-3">
                            <div className="flex items-center justify-between">
                                <dt className="text-muted-foreground">Customer</dt>
                                <dd>Liam Johnson</dd>
                            </div>
                            <div className="flex items-center justify-between">
                                <dt className="text-muted-foreground">Email</dt>
                                <dd>
                                    <a href="mailto:">{orderInfo.email}</a>
                                </dd>
                            </div>
                            <div className="flex items-center justify-between">
                                <dt className="text-muted-foreground">Phone</dt>
                                <dd>
                                    <a href="tel:">{orderInfo.phone}</a>
                                </dd>
                            </div>
                        </dl>
                    </div>
                    {/* <Separator className="my-4" />
                    <div className="grid gap-3">
                        <div className="font-semibold">Payment Information</div>
                        <dl className="grid gap-3">
                            <div className="flex items-center justify-between">
                                <dt className="flex items-center gap-1 text-muted-foreground">
                                    <CreditCard className="h-4 w-4" />
                                    Visa
                                </dt>
                                <dd>**** **** **** 4532</dd>
                            </div>
                        </dl>
                    </div> */}
                </CardContent>
                <CardFooter className="flex flex-row items-center border-t bg-muted/50 px-6 py-3">
                    <div className="text-xs text-muted-foreground">
                        Updated <time dateTime="2023-11-23">November 23, 2023</time>
                    </div>
                    <Pagination className="ml-auto mr-0 w-auto">
                        {/* <PaginationContent>
                            <PaginationItem>
                                <Button
                                    size="icon"
                                    variant="outline"
                                    className="h-6 w-6"
                                >
                                    <ChevronLeft className="h-3.5 w-3.5" />
                                    <span className="sr-only">Previous Order</span>
                                </Button>
                            </PaginationItem>
                            <PaginationItem>
                                <Button
                                    size="icon"
                                    variant="outline"
                                    className="h-6 w-6"
                                >
                                    <ChevronRight className="h-3.5 w-3.5" />
                                    <span className="sr-only">Next Order</span>
                                </Button>
                            </PaginationItem>
                        </PaginationContent> */}
                    </Pagination>
                </CardFooter>
            </Card>
        </main>
    );
};
